import { Injectable } from '@angular/core';
import { QueryEntity } from '@examdojo/state';
import { distinctUntilChanged, map, of, switchMap } from 'rxjs';
import { ClassAssignmentQuery } from '../class-assignment/class-assignment.query';
import { ClassState, ClassStore } from './class.store';
import { ClassStoreModel, ClassUIModel } from './class.model';

@Injectable({ providedIn: 'root' })
export class ClassQuery extends QueryEntity<ClassState, ClassStoreModel, ClassUIModel, 'id'> {
  constructor(
    protected override readonly store: ClassStore,
    private readonly classAssignmentQuery: ClassAssignmentQuery,
  ) {
    super(store);
  }

  readonly activeEntities$ = this.entities$.pipe(map((classes) => classes.filter((c) => !c.archived_at)));
  readonly isActiveArchived$ = this.selectActive().pipe(
    map((c) => !!c?.archived_at),
    distinctUntilChanged(),
  );

  readonly hasAssignments$ = this.selectActive().pipe(
    switchMap((activeClass) =>
      activeClass ? this.classAssignmentQuery.selectHasAssignmentsForClass(activeClass.id) : of(false),
    ),
    distinctUntilChanged(),
  );
}
